import { ImageEditorConfig } from "../types";

import { ImageDimensions } from "@/common/types/image";

const DEFAULT_SQUARE_TARGET_SIZE = 800;

export interface ResolvedEditorConfig {
  useSquareEditor: boolean;
  targetSize: number;
  centerFit: boolean;
  whiteBackground: boolean;
  previewSize: number | undefined;
  showRatioPresets: boolean | undefined;
  maxDimensions: ImageDimensions | undefined;
  preserveTransparency: boolean | undefined;
  disableCrop: boolean;
  keepGifAnimation: boolean;
}

export const resolveEditorConfig = (config: ImageEditorConfig, isSmallScreen: boolean): ResolvedEditorConfig => {
  const isSquare = config.kind === "square";
  return {
    useSquareEditor: isSquare,
    targetSize: isSquare ? config.targetSize : DEFAULT_SQUARE_TARGET_SIZE,
    centerFit: isSquare ? (config.centerFit ?? false) : false,
    whiteBackground: isSquare ? (config.whiteBackground ?? false) : false,
    previewSize: isSquare ? config.previewSize : undefined,
    showRatioPresets: config.kind === "crop" ? config.showRatioPresets : undefined,
    maxDimensions: config.kind === "crop" ? config.maxDimensions : undefined,
    preserveTransparency: isSquare ? config.preserveTransparency : undefined,
    disableCrop:
      config.kind === "crop" && (((config.disableOnMobile ?? false) && isSmallScreen) || (config.disabled ?? false)),
    keepGifAnimation: config.kind === "crop" && (config.keepGifAnimation ?? false),
  };
};
